import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { VehicleBrandModel } from "../_types/vehicleBrandModel";

@Injectable({
    providedIn: 'root',
})

export class VehiclesBrandsModelsService extends Service<VehicleBrandModel> {
  public override type = 'vehicleBrandsModels';
  public override url = 'providers/vehicleBrandsModels'; 
    
}
